/**
 * tokenStore.js
 *
 * A module-level (singleton) in-memory store for the JWT access token.
 * This is intentionally NOT in React state — it must be readable by Axios
 * interceptors which live outside the React component tree.
 *
 * The access token is NEVER written to localStorage.
 * It lives only in memory and is re-acquired via the silent refresh flow
 * (using the HttpOnly vetcollab_rt cookie) when the page is reloaded.
 */

let _accessToken = null;
let _refreshingPromise = null;

export const getAccessToken = () => _accessToken;
export const setAccessToken = (token) => { _accessToken = token; };
export const clearAccessToken = () => { _accessToken = null; };

/** Returns (or creates) the single in-flight refresh promise so parallel
 *  401 retries queue up behind one refresh request instead of firing many. */
export const getRefreshingPromise = () => _refreshingPromise;
export const setRefreshingPromise = (p) => { _refreshingPromise = p; };
export const clearRefreshingPromise = () => { _refreshingPromise = null; };

/** Read the CSRF token from the vetcollab_csrf cookie or fallback to localStorage in cross-domain environments. */
export const getCsrfToken = () => {
  const fromCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('vetcollab_csrf='))
    ?.split('=')[1];
  
  if (fromCookie) return fromCookie;
  
  return localStorage.getItem('csrf') ?? null;
};
